import React, {useState, useMemo} from 'react'
import {IconButton, Modal, Button} from '@material-ui/core'
import {Close} from '@material-ui/icons'
import moment from 'moment'

// custom components
import {Tab, TabPanel, Tabs} from '../CalendarEventPopup/Tabs'

import useGetReservationItemDetails from '../../state/get-reservation-item-details/reducer'
// styles
// will use styles calendar event popup
import _ from 'lodash'

const CalendarEventGroupDatePopup = ({onClose, open, data = {}}) => {
  const [tabIndex, setTabIndex] = useState(0)
  const {field = {}, raw, entity_object = {}} = data || {}

  const entity_object_id = entity_object?.id || data?.entity_object_id
  const entity_key = data?.entity_key

  const field_value = useMemo(() => {
    if (entity_object?.data) {
      return moment(entity_object?.data[raw?.key]).format('YYYY-MM-DD hh:mm a')
    } else {
      return moment(data?.start).format('YYYY-MM-DD hh:mm a')
    }
  }, [data, entity_object, raw])

  const [reservation, dispatch] = useGetReservationItemDetails()
  const {status = '', states = ''} = reservation.data || {}

  const [full_value, new_value] = useMemo(() => {
    let reservationID = ''
    const prepareValue = val => {
      let display_value
      if ((val !== null && val !== undefined && val.length > 0) || typeof val == 'number') {
        display_value = `${val},`
      } else {
        display_value = ''
      }
      return display_value
    }
    if (!_.isEmpty(data?.reservation_uid)) {
      reservationID = `#${data?.reservation_uid},`
    } else if (!_.isEmpty(data?.entity_display_name)) {
      reservationID = data?.entity_display_name
    }
    const first_name = prepareValue(data.display_name_first || entity_object?.display_name)
    const second_name = prepareValue(
      data.display_with_secondary || entity_object?.display_with_secondary
    )
    const third_name = prepareValue(data.display_name_third || entity_object?.display_name_third)
    const full_value = `${first_name} ${second_name} ${third_name}`.replace(/,\s*$/, '')
    const _new_value =
      full_value.trim() !== '' ? full_value : `${reservationID}`.replace(/,\s*$/, '')
    const _full_value =
      full_value.trim() !== '' ? full_value : `${reservationID} ${status} - ${states}`
    return [_full_value, _new_value]
  }, [data, status, states, entity_object])

  return (
    <Modal open={!!open} onClose={onClose}>
      <>
        <div
          className="c-res-mod c-calendar-event-popup"
          style={{borderLeft: `8px solid ${data.bgColor ? data.bgColor : data.color}`}}
        >
          <div
            className="c-calendar-event-popup__header"
            // style={{backgroundColor: `${data.bgColor ? data.bgColor : data.color}3f`}}
          >
            <h4 className="c-calendar-event-popup__header-title ap-typography ap-typography--lg ap-typography--light ap-ellipsis">
              <a
                style={{color: 'inherit'}}
                href={`${localStorage.parent_origin}/${entity_key}/${entity_object_id}`}
                target="_top"
                className="tooltip-header-title"
              >
                {new_value}
                <span className="tooltip-after"></span>
                <span className="tooltip-title-text">{full_value}</span>
              </a>
            </h4>
            {/* <IconButton
              className="c-calendar-event-popup__header-close ap-icon-button ap-icon-button--square"
              size="small"
              onClick={onClose}
            >
              <Close />
            </IconButton> */}
          </div>

          <div className="c-calendar-event-popup__body">
            <div className="c-calendar-event-popup__tab-wrapper">
              <Tabs>
                <Tab
                  active={tabIndex === 0}
                  onClick={e => setTabIndex(0)}
                  style={{borderColor: `${data.bgColor ? data.bgColor : data.color}`}}
                  title={field?.field_name || data?.field_name}
                  className="tab-count-1"
                >
                  {field?.field_name || data?.field_name}
                </Tab>
              </Tabs>
              <TabPanel active={tabIndex === 0}>
                <p className="tab-label ap-m-0 ap-typography ap-typography--xs ap-typography--gray">
                  Date
                </p>
                <p className="tab-label-value ap-m-0 ap-typography ap-typography--sm">
                  {field_value}
                </p>
              </TabPanel>
            </div>
          </div>
          <div className="c-calendar-event-popup__footer">
            <Button
              onClick={onClose}
              style={{width: 80, textTransform: 'capitalize'}}
              // className="cancel-btn ap-button ap-button--text font-bold color-303A52 mt--1"
            >
              Close
            </Button>
          </div>
        </div>
      </>
    </Modal>
  )
}

export default CalendarEventGroupDatePopup
